import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Placeholder } from "react-bootstrap";
import { BlogRecord, getPublishedBlogs } from "../../../services/blogService";

const formatDate = (value?: string | null) => {
	if (!value) {
		return "";
	}
	return new Date(value).toLocaleDateString(undefined, {
		year: "numeric",
		month: "short",
		day: "numeric",
	});
};

const HomePageNewsRow: React.FC = () => {
	const [articles, setArticles] = useState<BlogRecord[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		let active = true;

		const fetchLatestNews = async () => {
			try {
				setLoading(true);
				const res = await getPublishedBlogs({ page: 1, limit: 8 });
				if (!active) {
					return;
				}
				setArticles(res.data?.items || []);
			} catch (error) {
				console.error("Failed to fetch homepage news:", error);
				if (active) {
					setArticles([]);
				}
			} finally {
				if (active) {
					setLoading(false);
				}
			}
		};

		void fetchLatestNews();

		return () => {
			active = false;
		};
	}, []);

	return (
		<section className="homepage-news-row">
			<div className="homepage-news-row__header">
				<h3 className="homepage-news-row__title">Latest News</h3>
				<Link to="/news" className="homepage-news-row__view-all">
					View all
				</Link>
			</div>

			<div className="homepage-news-row__track">
				{loading ? (
					Array.from({ length: 4 }).map((_, idx) => (
						<div className="homepage-news-row__item" key={`news-skeleton-${idx}`}>
							<Placeholder as="div" animation="glow">
								<Placeholder
									xs={12}
									bg="light"
									className="rounded-3 mb-2"
									style={{ height: "110px" }}
								/>
								<Placeholder xs={4} bg="light" className="rounded-3 mb-2" />
								<Placeholder xs={10} bg="light" className="rounded-3 mb-1" />
								<Placeholder xs={8} bg="light" className="rounded-3" />
							</Placeholder>
						</div>
					))
				) : articles.length > 0 ? (
					articles.map((article, index) => (
						<Link
							to={`/news/${article.slug}`}
							key={article._id}
							className="homepage-news-row__item homepage-news-row__link"
						>
							<div className="homepage-news-row__image-wrap">
								{article?.coverImage?.url ? (
									<img
										src={article.coverImage.url}
										alt={article.title}
										className="homepage-news-row__image"
									/>
								) : (
									<div className="homepage-news-row__image homepage-news-row__image--empty" />
								)}
								{index === 0 ? (
									<span className="homepage-news-row__latest-tag">LATEST</span>
								) : null}
							</div>
							<div className="homepage-news-row__date">
								{formatDate(article.publishedAt)}
							</div>
							<div className="homepage-news-row__headline">{article.title}</div>
						</Link>
					))
				) : (
					<div className="homepage-news-row__empty">No published news yet.</div>
				)}
			</div>
		</section>
	);
};

export default HomePageNewsRow;
